

























import { Component, Vue, Prop } from 'vue-property-decorator'
import { Game } from '@/class/game'
import { GamePlayer } from '@/class/gamePlayer'
import { RoleId } from '@/enum'
import Card from '@/components/Common/Card/Card.vue'

@Component({
  components: {
    Card,
  }
})
export default class RoleList extends Vue {
  @Prop() game!: Game;
  @Prop() player!: GamePlayer;

  get useRoles () {
    return this.game.useRoles
  }

  click(roleId: RoleId | null) {
    if (this.player.selfAppointedRoleId === roleId) return;

    this.$emit('proclaim', roleId)
  }
}
